var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFollowers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01474 1C6.25151 1 3.9912 3.26193 3.9912 6.02516C3.9912 7.71475 4.8388 9.21096 6.12737 10.1212C3.12783 11.3237 1.00026 14.2575 1.00026 17.6797C0.976314 18.7586 2.60701 18.7586 2.58306 17.6797C2.58306 14.0472 5.512 11.1198 9.14458 11.1198C10.4126 11.1198 11.5897 11.4812 12.5915 12.1012C13.4921 12.6536 14.3206 11.3027 13.42 10.7504C12.9689 10.4713 12.4802 10.2536 11.9763 10.0656C13.2202 9.15061 14.0337 7.68116 14.0337 6.02516C14.0337 3.26193 11.778 1 9.01474 1ZM9.01474 2.58438C10.9226 2.58438 12.4508 4.11733 12.4508 6.02516C12.4508 7.93298 10.9226 9.45963 9.01474 9.45963C7.10692 9.45963 5.574 7.93298 5.574 6.02516C5.574 4.11733 7.10692 2.58438 9.01474 2.58438ZM15.0407 16.57V18.1528C15.0636 19.1849 16.6006 19.1849 16.6235 18.1528V16.57H18.2078C19.2641 16.57 19.2641 14.9857 18.2078 14.9857H16.6235V13.4029C16.6286 12.9592 16.2681 12.5978 15.8243 12.6022C15.3867 12.6052 15.0356 12.9652 15.0407 13.4029V14.9857H13.42C12.3259 15.0363 12.4016 16.6205 13.4579 16.57H15.0407Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowers);
export default __webpack_public_path__ + "static/media/Followers.127bacc4424ec889351b8799aa260cd2.svg";
export { ForwardRef as ReactComponent };